<template>
  <v-layout row wrap class="ch-search-filter-wrapper">
    <v-flex xs12 class="ch-search-filter pb-0 pt-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container fluid grid-list-lg class="pt-0 pb-0">
          <v-layout row wrap class="filter-wrap">
            <button class="form-clear-btn" @click.prevent="clearAllField">
              <i class="fas fa-eraser"></i>
              <span>CLEAR</span>
            </button>
            <v-flex xs2 class="pl-0 pr-0" v-if="visibleDomain">
              <v-select
                :items="filterDomainItems"
                v-model="filterDomainInput"
                label="Domain"
                bottom
                @click.native="getDomainList"
                @focus.native="getDomainList"
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-text-field
                v-model="filterUserEmail"
                label="Email"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-text-field
                v-model="filterUserName"
                label="Name"
                single-line
                hide-details
                clearable
              ></v-text-field> 
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { adminsEventBus } from '@/components/admin/admins/adminsEventBus';
  import api from '../../../api';

  export default {
    props: ['storeFilter'],
    data() {
      return {
        // NOTE: 모든 검색어
        allSearch: {
          userName: {
            search: null,
            searchCategory: 'name',
          },
          userEmail: {
            search: null,
            searchCategory: 'email',
          },
          domain: {
            search: null,
            searchCategory: 'domain_id',
          },
        },
        valid: true,
        // NOTE: Filter
        filterDomain: null,
        filterDomainItems: [],
        visibleDomain: false,
        filterUserName: null,
        filterUserEmail: null,
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        if (!_.isEmpty(this.storeFilter)) {
          console.log('this.storeFilter not empty');
          const filter = Object.values(this.storeFilter).filter(item => item.search !== null);
          const arr = Object.keys(this.allSearch);
          for (let i = 0; i < arr.length; i += 1) {
            for (let j = 0; j < filter.length; j += 1) {
              if (this.allSearch[arr[i]].searchCategory === filter[j].searchCategory) {
                this.allSearch[arr[i]].search = filter[j].search;
                switch (this.allSearch[arr[i]].searchCategory) {
                  case 'name':
                    this.filterUserName = filter[j].search;
                    break;
                  case 'email':
                    this.filterUserEmail = filter[j].search;
                    break;
                  case 'domain_id':
                    this.filterDomain = filter[j].search;
                    this.getDomainList();
                    break;
                  default:
                    break;
                }
              }
            }
          }
          this.$nextTick(() => {
            console.log('this.$nextTick');
            adminsEventBus.$emit('initFilter', this.allSearch);
          });
        }
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      getDomainList() {
        console.log('getDomainList');
        api.getDomainList()
        .then((result) => {
          if (result.status === 200) {
            this.filterDomainItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
       * @param { Object } object, this.allSearch
       */
      getInputValue: _.debounce((obj) => {
        adminsEventBus.$emit('customFilter', obj);
        storeFilterEventBus.$emit('setFilter', obj);
      }, 100),
    },
    computed: {
      filterDomainInput: {
        get() {
          return this.filterDomain;
        },
        set(newValue) {
          console.log('filterDomainInput');
          this.filterDomain = newValue;
          this.allSearch.domain.search = newValue;
          adminsEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
    },
    watch: {
      /**
       * @description 작업을 실행할 수 있는 빈도를 제한합니다
       */
      filterUserName(newValue) {
        console.log('filterUserName');
        this.allSearch.userName.search = newValue;
        this.getInputValue(this.allSearch);
      },
      filterUserEmail(newValue) {
        console.log('filterUserEmail');
        this.allSearch.userEmail.search = newValue;
        this.getInputValue(this.allSearch);
      },
    },
    created() {
      if (localStorage.getItem('domain_type') === 'root') {
        this.visibleDomain = true;
      }
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      adminsEventBus.$off('initFilter');
      adminsEventBus.$off('customFilter');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/admins/AdminsFilter.vue